var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SlidePagination lxn-w100 lxn-h100"},_vm._l((_vm.bullets),function(bullet,index){return _c('div',{key:index,staticClass:"SlidePagination-bullet lxn-h100 lxn-float-left lxn-border-round",class:bullet.bulletClass,style:(bullet.bulletStyle),on:{"click":function($event){return _vm.$emit('click', index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }